import { isServer } from 'lib/common/constants';

export const createListCacheLimit = (minutes: number): number =>
  (isServer ? 0 : performance.now()) + 60 * 1000 * minutes;

export const isListCacheInvalid = (prevcacheLimit: number = 0): boolean =>
  performance.now() < prevcacheLimit;

export const removeThunkRequestTypes = (actionType: string) =>
  actionType.replace(/_(REQUEST|FAILURE|SUCCESS)/, '');
